import * as React from "react";
import type { SVGProps } from "react";

const SvgMail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={14}
    viewBox="0 0 18 14"
    {...props}
  >
    <path
      fill="#0C5641"
      fillRule="evenodd"
      d="M16.2 0H1.8C.81 0 .009.787.009 1.75L0 12.25C0 13.213.81 14 1.8 14h14.4c.99 0 1.8-.787 1.8-1.75V1.75C18 .787 17.19 0 16.2 0m0 12.25H1.8V3.5L9 7.875 16.2 3.5zM9 6.125 1.8 1.75h14.4z"
    />
  </svg>
);
export default SvgMail;
